import 'react-toastify/dist/ReactToastify.css';
import * as React from 'react';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import Paper from '@mui/material/Paper';
import Select from 'react-select';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  ModalFooter,
} from 'reactstrap';
const CheckboxOption = (props) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        cursor: 'pointer',
        backgroundColor: props.isFocused ? '#f0f0f0' : 'white',
      }}
      onClick={() => props.selectOption(props.data)}
    >
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: '10px', cursor: 'pointer', accentColor: '#00C0CB' }}
      />
      <label style={{ margin: 0, cursor: 'pointer', fontSize: '14px' }}>
        {props.label}
      </label>
    </div>
  );
};
export default function DataGridTable({
  userDataTable,
  fetchDataTable,
  fetchData,
}) {
  const [selectedUser, setSelectedUser] = useState(null);

  const navigate = useNavigate();
  const user_token = localStorage.getItem('usertoken');
  //usestates
  const [userData, setuserData] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [selectedUniversities, setSelectedUniversities] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [units, setUnits] = useState([]);
  const [selectedunits, setSelectedunits] = useState(new Set());

  const [role, setRole] = useState('');
  const [selectedTabs, setSelectedTabs] = useState(new Set());
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setemail] = useState('');
  const [emailform, setEmaliform] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  //validation

  const tabOptions = [
    { value: 1, label: 'Overview' },
    { value: 2, label: 'Unit Overview' },
    { value: 3, label: 'Unit Details' },
    { value: 4, label: 'Staff Overview' },
    { value: 5, label: 'Staff Details' },
  ];

  // ✅ FIX: Now accepts row as parameter
  const handleDelete = async (row) => {
    const payload = {
      mode: 'delete_personnel',
      personnel_id: row.id,
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      const message = response?.message || '';

      if (message.includes('User Personnel Removed!')) {
        toast.success('User Deleted Successfully');
      } else {
        toast.error('User Delete Failed');
      }
      fetchDataTable();
      fetchData();

      // const message = response.message || "";

      // if (message.includes("User Personnel Removed!")) {
      //   toast.success("User Deleted Successfully");
      // } else {
      //   toast.error("User Delete Failed");
      // }
    } catch (error) {
      console.error('Delete Failed:', error);
    }
  };
  // const ProgramOptions = programs.map(program => ({
  //   value: program.id,
  //   label: program.name
  // }));

  // const unitsOptions = units.map(unit => ({
  //   value: unit.id,
  //   label: unit.name
  // }));
  // const allProgramsOption = { value: 'all', label: 'All' };
  // const ProgramOptions = programs.map(program => ({
  //   value: program.id,
  //   label: program.name
  // }));
  // const ProgramOptionsWithAll = [allProgramsOption, ...ProgramOptions];
  // const allUnitsOption = { value: 'all', label: 'All' };
  // const unitsOptions = units.map(unit => ({
  //   value: unit.id,
  //   label: unit.name
  // }));
  // const unitsOptionsWithAll = [allUnitsOption, ...unitsOptions];

  // For select options
  const allProgramsOption = { value: 'all', label: 'All' };
  const ProgramOptions = programs.map((program) => ({
    value: program.id,
    label: program.name,
  }));
  const ProgramOptionsWithAll = [allProgramsOption, ...ProgramOptions];

  const allUnitsOption = { value: 'all', label: 'All' };
  const unitsOptions = units.map((unit) => ({
    value: unit.id,
    label: unit.name,
  }));
  const unitsOptionsWithAll = [allUnitsOption, ...unitsOptions];

  // useEffect to pre-fill selected sets
  // useEffect(() => {
  //   if (selectedUser) {
  //     if (selectedUser.program_ids) {
  //       setSelectedPrograms(new Set(selectedUser.program_ids));
  //     }
  //     if (selectedUser.unit_ids) {
  //       setSelectedunits(new Set(selectedUser.unit_ids));
  //     }
  //   }
  // }, [selectedUser]);
  useEffect(() => {
  if (selectedUser) {
    if (selectedUser.program_ids) {
      setSelectedPrograms(new Set(selectedUser.program_ids));
    }
    if (selectedUser.unit_ids) {
      setSelectedunits(new Set(selectedUser.unit_ids));
    }
  }
}, [selectedUser?.id]);

  const universityOptions = universities.map((uni) => ({
    value: uni.id, // numeric ID like 15
    label: uni.short_name, // "VU", "ATU", etc.
  }));

  const handleDeleterow = (row) => {
    setRowToDelete(row); // Store row to delete
    setOpenConfirmDialog(true); // Open confirmation dialog
  };

  const confirmDelete = () => {
    if (rowToDelete) {
      handleDelete(rowToDelete);
      setRowToDelete(null);
      setOpenConfirmDialog(false);
    }
  };

  const cancelDelete = () => {
    setRowToDelete(null);
    setOpenConfirmDialog(false);
  };

  //edit user

  const [modalOpenEdit, setmodalOpenEdit] = useState(false);
  const toggleModalEdit = () => {
    setValidationErrors({});
    setmodalOpenEdit(!modalOpenEdit);
  };

  const handleEdit = (row) => {
    setSelectedUser(row); // Set the clicked row data
    toggleModalEdit(); // Open the modal
  };

  //useEffects

  const fetchDataUniversity = async () => {
    try {
      const payload = {
        mode: 'universities',
      };

      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setUniversities(response.data || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    fetchDataUniversity();
  }, []);
  useEffect(() => {
    const universitiesToUse =
      selectedUser?.university_ids || selectedUniversities;

    if (universitiesToUse && universitiesToUse.length > 0) {
      fetchDataPrograms(universitiesToUse);
    }
  }, [selectedUser?.university_ids, selectedUniversities]);

  const fetchDataPrograms = async () => {
    const universityIds = selectedUser?.university_ids || selectedUniversities;

    try {
      const payload = {
        university: universityIds, // should be [15, 22], not ["VU", "ATU"]
        mode: 'programs',
      };

      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setPrograms(response.data || []);
    } catch (error) {
      // console.log("Error fetching program data:", error);
    }
  };

  useEffect(() => {
    const universitiesToUse = selectedUser?.program_ids || selectedPrograms;

    if (universitiesToUse && universitiesToUse.length > 0) {
      fetchDataunits(universitiesToUse);
    }
  }, [selectedUser?.program_ids, selectedPrograms]);

  const fetchDataunits = async () => {
    const programids = selectedUser?.program_ids || selectedPrograms;

    try {
      const payload = {
        program: programids, // should be [15, 22], not ["VU", "ATU"]
        mode: 'units',
      };

      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setUnits(response.data || []);
    } catch (error) {
      // console.log("Error fetching program data:", error);
    }
  };

  const handleEditForm = async (e) => {
    const errors = {};

    if (!selectedUser?.username?.trim()) {
      errors.username = 'Username is required.';
    }
    if (!selectedUser?.email?.trim()) {
      errors.email = 'Email is required.';
    }
    if (!selectedUser?.role || selectedUser.role === 'selectrole') {
      errors.role = 'Role is required.';
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // If no errors
    setValidationErrors({});
    // Proceed with your save logic
    // ...
    e.preventDefault();

    const newUserData = {
      user_id: selectedUser?.id || 'null',
      first_name: selectedUser.firstName || 'null',
      last_name: selectedUser.lastName || 'null',
      email: selectedUser.email || 'null',
      contact_number: selectedUser.contact || 'null',
      role: selectedUser.role || 'null',
      designation: 'null',
      universities: selectedUser.university_ids?.length
        ? selectedUser.university_ids
        : null,
      // programs: selectedUser.program_ids?.length ? selectedUser.program_ids : null,
      // units: selectedUser.unit_ids?.length ? selectedUser.unit_ids : null,
      programs: selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
      units: selectedunits.size > 0 ? Array.from(selectedunits) : null,
      tabs: selectedUser.tab_ids?.length ? selectedUser.tab_ids : null,
    };

    const payload = {
      new_user_data: newUserData,
      mode: 'update_personnel_user',
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      // console.log("Submission Success:", response.data);
      toggleModalEdit(); // close modal on success
      fetchDataTable();
      fetchData();
      setSelectedUser(null);
      setFirstName('');
      setLastName('');
      setEmaliform('');
      setRole('');
      setSelectedUniversities([]);
      setSelectedPrograms(new Set());
      setSelectedunits(new Set());
      setSelectedTabs(new Set());
      document.getElementById('contact').value = '';
      if (response.message?.toLowerCase().includes('success')) {
        toast.success('User Edited Successfully');
      } else {
        toast.error('User Edited Failed');
      }
    } catch (error) {
      console.error('Submission Failed:', error);
    }
  };

  const columns = [
    {
      field: 'sno',
      headerName: 'S.No',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      sortable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    {
      field: 'username',
      headerName: 'Username',
      width: 200,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'firstName',
      headerName: 'First Name',
      width: 200,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      width: 200,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 250,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'contact',
      headerName: 'Contact',
      width: 180,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'role',
      headerName: 'Role',
      width: 180,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'universities',
      headerName: 'Universities',
      width: 250,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <div
          style={{
            width: '100%',
            height: '100%',
            maxHeight: '100px', // Adjust height if needed
            overflowY: 'auto',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.5',
            padding: '8px',
            boxSizing: 'border-box',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: 'programs',
      headerName: 'Programs',
      width: 250,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <div
          style={{
            width: '100%',
            height: '100%',
            maxHeight: '100px',
            overflowY: 'auto',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.5',
            padding: '8px',
            boxSizing: 'border-box',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: 'units',
      headerName: 'Units',
      width: 200,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <div
          style={{
            width: '100%',
            height: '100%',
            maxHeight: '100px',
            overflowY: 'auto',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.5',
            padding: '8px',
            boxSizing: 'border-box',
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      field: 'tabs',
      headerName: 'Tabs',
      flex: 1,
      minWidth: 200,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <div
          style={{
            width: '100%',
            height: '100%',
            maxHeight: '100px', // Set max height for scroll (adjust as needed)
            overflowY: 'auto', // Enables vertical scrollbar if content overflows
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.5',
            display: 'flex',
            alignItems: 'flex-start',
            padding: '8px',
            boxSizing: 'border-box',
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="text"
            color="primary"
            size="small"
            onClick={() => handleEdit(params.row)}
          >
            <EditIcon fontSize="small" />
          </Button>
          <Button
            variant="text"
            color="error"
            size="small"
            onClick={(e) => {
              e.preventDefault();
              handleDeleterow(params.row);
            }}
          >
            <DeleteIcon fontSize="small" />
          </Button>
        </>
      ),
    },
  ];

  const rows = (userDataTable || []).map((item, index) => ({
    id: item.id,
    sno: index + 1,
    username: item.name,
    firstName: item.first_name,
    lastName: item.last_name,
    email: item.email,
    contact: item.contact,
    role: item.role,
    universities: item.universities,
    programs: item.programs,
    units: item.units,
    tabs: item.tabs,
    contact: item.contact_number,
    university_ids: item.university_ids || [], // Add these fields
    program_ids: item.program_ids || [],
    unit_ids: item.unit_ids || [],
    tab_ids: item.tab_id || [],
  }));

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });


  
  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
        <div style={{ width: '100%' }}>
          <div className="d-flex justify-content-end mb-2">
            {/* Add export or other buttons here if needed */}
          </div>
          <DataGrid
            rows={rows}
            columns={columns}
            paginationModel={paginationModel}
            onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
            autoHeight
            rowCount={rows.length}
            pageSizeOptions={[20, 50, 100]}
            sx={{
              'fontFamily': 'Nunito Sans, sans-serif',
              'fontSize': '14px',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#ebebeb',
                color: '#000',
                fontWeight: 'bold',
                fontSize: '14px',
                padding: '6px',
                fontFamily: 'Nunito Sans, sans-serif',
              },
              '& .MuiDataGrid-cell': {
                padding: '6px',
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
              },
              '& .MuiDataGrid-row:hover': {
                cursor: 'pointer',
                backgroundColor: '#f5f5f5',
              },
            }}
          />
        </div>
      </Paper>

      <Modal
        isOpen={modalOpenEdit}
        toggle={toggleModalEdit}
        style={{ width: '80%' }}
      >
        <ModalHeader toggle={toggleModalEdit}>Edit User Personnel</ModalHeader>
        <ModalBody className="modal-body">
          <Form>
            <FormGroup>
              <Label for="username">
                Username
                <span className="mandatory">*</span>
              </Label>
              <Input
                type="text"
                id="username"
                value={selectedUser?.username || ''}
                onChange={(e) =>
                  setSelectedUser({ ...selectedUser, username: e.target.value })
                }
              />
              {validationErrors.username && (
                <div className="invalid-feedback d-block">
                  {validationErrors.username}
                </div>
              )}
            </FormGroup>

            {/* <FormGroup>
              <Label for="firstName">First Name</Label>
              <Input
                type="text"
                id="firstName"
                value={selectedUser?.firstName || ""}
                onChange={(e) =>
                  setSelectedUser({ ...selectedUser, firstName: e.target.value })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label for="lastName">Last Name</Label>
              <Input
                type="text"
                id="lastName"
                value={selectedUser?.lastName || ""}
                onChange={(e) =>
                  setSelectedUser({ ...selectedUser, lastName: e.target.value })
                }

              />
            </FormGroup> */}
            <FormGroup>
              <Label for="firstName">First Name</Label>
              <Input
                type="text"
                id="firstName"
                value={selectedUser?.firstName || ''} // <-- Show existing firstName
                onChange={(e) =>
                  setSelectedUser((prev) => ({
                    ...prev,
                    firstName: e.target.value, // <-- Update firstName when typing
                  }))
                }
              />
            </FormGroup>

            <FormGroup>
              <Label for="lastName">Last Name</Label>
              <Input
                type="text"
                id="lastName"
                value={selectedUser?.lastName || ''} // <-- Show existing lastName
                onChange={(e) =>
                  setSelectedUser((prev) => ({
                    ...prev,
                    lastName: e.target.value, // <-- Update lastName when typing
                  }))
                }
              />
            </FormGroup>

            <FormGroup>
              <Label for="email">
                Email
                <span className="mandatory">*</span>
              </Label>
              <Input
                type="email"
                id="email"
                value={selectedUser?.email || ''}
                onChange={(e) =>
                  setSelectedUser({ ...selectedUser, email: e.target.value })
                }
              />
              {validationErrors.email && (
                <div className="invalid-feedback d-block">
                  {validationErrors.email}
                </div>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="contact">Contact</Label>
              <Input
                type="text"
                id="contact"
                value={selectedUser?.contact || ''}
                onChange={(e) =>
                  setSelectedUser({ ...selectedUser, contact: e.target.value })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label for="role">Role</Label>
              <span className="mandatory">*</span>

              <Input
                // type="select"
                // id={role}
                // value={selectedUser?.role || ""}
                // onChange={(e) =>
                //   setSelectedUser({ ...selectedUser, role: e.target.value })
                // }

                type="select"
                id={role}
                value={selectedUser?.role || ''}
                onChange={(e) => {
                  const newRole = e.target.value;

                  if (newRole === 'Admin') {
                    setSelectedUser((prev) => ({
                      ...prev,
                      role: newRole,
                      universities: '',
                      university_ids: [],
                      programs: '',
                      program_ids: [],
                      units: '',
                      unit_ids: [],
                      tabs: '',
                      tab_ids: [],
                    }));

                    setSelectedUniversities([]);
                    setPrograms([]);
                    setSelectedPrograms(new Set());
                    setUnits([]);
                    setSelectedunits(new Set());
                  } else {
                    setSelectedUser((prev) => ({
                      ...prev,
                      role: newRole,
                    }));
                  }

                  setRole(newRole);
                }}
              >
                <option value="selectrole">Select Role</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
              </Input>
              {validationErrors.role && (
                <div className="invalid-feedback d-block">
                  {validationErrors.role}
                </div>
              )}
            </FormGroup>

            {selectedUser?.role !== 'Admin' && (
              <>
                <FormGroup>
                  <Label for="university">University</Label>
                  <Select
                    // id="university"
                    // isMulti
                    // closeMenuOnSelect={false}
                    // options={universityOptions} // [{ value: id, label: short_name }]
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                    // placeholder="Select University"
                    // // Match selected options by comparing IDs
                    // value={universityOptions.filter((opt) =>
                    //   selectedUser?.university_ids?.includes(opt.value),
                    // )}
                      id="university"
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CheckboxOption }}
                    options={universityOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select University"
                    value={universityOptions.filter((opt) =>
                      selectedUser?.university_ids?.includes(opt.value),
                    )}
                   
                    onChange={(selected) => {
                      const newUniversityIds =
                        selected?.map((item) => item.value) || [];
                      const newUniversityLabels =
                        selected?.map((item) => item.label) || [];

                      const removedUniversityLabels = (
                        selectedUser?.universities?.split(', ') || []
                      ).filter((uni) => !newUniversityLabels.includes(uni));

                      // Filter out programs that belong to removed universities
                      const filteredProgramOptions = ProgramOptions.filter(
                        (program) =>
                          !removedUniversityLabels.some((removed) =>
                            program.label.startsWith(removed),
                          ),
                      );

                      const newProgramIds =
                        selectedUser?.program_ids?.filter((id) =>
                          filteredProgramOptions.some(
                            (opt) => opt.value === id,
                          ),
                        ) || [];

                      const newProgramLabels = filteredProgramOptions
                        .filter((opt) => newProgramIds.includes(opt.value))
                        .map((opt) => opt.label);

                      // Filter out units that belong to removed universities
                      const filteredUnitOptions = unitsOptions.filter(
                        (unit) =>
                          !removedUniversityLabels.some((removed) =>
                            unit.label.startsWith(removed),
                          ),
                      );

                      const newUnitIds =
                        selectedUser?.unit_ids?.filter((id) =>
                          filteredUnitOptions.some((opt) => opt.value === id),
                        ) || [];

                      const newUnitLabels = filteredUnitOptions
                        .filter((opt) => newUnitIds.includes(opt.value))
                        .map((opt) => opt.label);

                      setSelectedUser((prev) => ({
                        ...prev,
                        universities: newUniversityLabels.join(', '),
                        university_ids: newUniversityIds,
                        programs: newProgramLabels.join(', '),
                        program_ids: newProgramIds,
                        units: newUnitLabels.join(', '),
                        unit_ids: newUnitIds,
                      }));

                      setSelectedUniversities(newUniversityIds); // for program fetch if needed
                    }}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="programs">Programs</Label>
                  <Select
                    // isMulti
                    // options={ProgramOptionsWithAll}
                    // value={Array.from(selectedPrograms).map((id) =>
                    //   id === 'all'
                    //     ? allProgramsOption
                    //     : ProgramOptions.find(
                    //         (option) => option.value === Number(id),
                    //       ),
                    // )}
                    isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option: CheckboxOption }}
                  options={ProgramOptionsWithAll}
                  // value={Array.from(selectedPrograms).map((id) =>
                  //   id === 'all'
                  //     ? allProgramsOption
                  //     : ProgramOptions.find((option) => option.value === Number(id)),
                  // )}
                                        value={
                        selectedPrograms.size === programs.length && programs.length > 0
                          ? [allProgramsOption, ...Array.from(selectedPrograms).map((id) =>
                              ProgramOptions.find((option) => option.value === Number(id))
                            ).filter(Boolean)]
                          : Array.from(selectedPrograms).map((id) =>
                              ProgramOptions.find((option) => option.value === Number(id))
                            ).filter(Boolean)
                      }
                         onChange={(selected, actionMeta) => {
                      const values = selected.map((opt) => opt.value);
                      const allIds = programs.map((p) => p.id);

                      // clicked "All" specifically
                      if (actionMeta?.option?.value === 'all') {
                        if (selectedPrograms.size === allIds.length) {
                          setSelectedPrograms(new Set()); // uncheck all
                        } else {
                          setSelectedPrograms(new Set(allIds)); // check all
                        }
                      } else {
                        // individual item clicked — filter out 'all' from values
                        setSelectedPrograms(new Set(values.filter((v) => v !== 'all')));
                      }
                    }}
                    placeholder="Select Programs"
                    noOptionsMessage={() =>
                      selectedUniversities.size === 0
                        ? 'Please select a University'
                        : 'No Programs Available'
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="units">Units</Label>
                  <Select
                    // isMulti
                    // options={unitsOptionsWithAll}
                    // value={Array.from(selectedunits).map((id) =>
                    //   id === 'all'
                    //     ? allUnitsOption
                    //     : unitsOptions.find(
                    //         (option) => option.value === Number(id),
                    //       ),
                    // )}
                    isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option: CheckboxOption }}
                  options={unitsOptionsWithAll}
                              value={
                selectedunits.size === units.length && units.length > 0
                  ? [allUnitsOption, ...Array.from(selectedunits).map((id) =>
                      unitsOptions.find((option) => option.value === Number(id))
                    ).filter(Boolean)]
                  : Array.from(selectedunits).map((id) =>
                      unitsOptions.find((option) => option.value === Number(id))
                    ).filter(Boolean)
                  }
                      onChange={(selected, actionMeta) => {
                      const values = selected.map((opt) => opt.value);
                      const allUnitIds = units.map((u) => u.id);

                      // clicked "All" specifically
                      if (actionMeta?.option?.value === 'all') {
                        if (selectedunits.size === allUnitIds.length) {
                          setSelectedunits(new Set()); // uncheck all
                        } else {
                          setSelectedunits(new Set(allUnitIds)); // check all
                        }
                      } else {
                        // individual item clicked — filter out 'all' from values
                        setSelectedunits(new Set(values.filter((v) => v !== 'all')));
                      }
                    }}
                    placeholder="Select Units"
                    noOptionsMessage={() =>
                      selectedPrograms.size === 0
                        ? 'Please Select a Program'
                        : 'No Units Available'
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="tabs">Tabs</Label>
                  <Select
                    // id="tabs"
                    // isMulti
                    // closeMenuOnSelect={false}
                    // options={tabOptions}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                    // placeholder="Select Tabs"
                    // value={tabOptions.filter((opt) =>
                    //   selectedUser?.tab_ids?.includes(opt.value),
                    // )}
                    id="tabs"
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CheckboxOption }}
                    options={tabOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Tabs"
                    value={tabOptions.filter((opt) =>
                      selectedUser?.tab_ids?.includes(opt.value),
                    )}
                    // onChange={(selected) => {
                    //   const selectedIds = selected.map((item) => item.value);
                    //   const selectedLabels = selected.map((item) => item.label);

                    //   setSelectedUser((prev) => ({
                    //     ...prev,
                    //     tabs: selectedLabels.join(', '), // for UI/table
                    //     tab_ids: selectedIds, // for backend/API
                    //   }));
                                  // }}
                  onChange={(selected) => {
                const selectedIds = selected.map((item) => item.value);
                const selectedLabels = selected.map((item) => item.label);

                setSelectedUser((prev) => ({
                  ...prev,
                  tabs: selectedLabels.join(', '),
                  tab_ids: selectedIds,
                  // preserve existing programs and units explicitly
                  program_ids: Array.from(selectedPrograms),
                  unit_ids: Array.from(selectedunits),
                }));
              }}
                  />
                </FormGroup>
              </>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            className="float-end mb-2 btn btn-primary"
            type="submit"
            onClick={handleEditForm}
            style={{
              backgroundColor: '#00C0CB',
              color: '#FFFFFF',
              fontFamily: '"Nunito Sans", sans-serif',
              fontSize: '14px',
              padding: '7.52px 12px',
              borderRadius: '8px',
              border: 'none',
              textTransform: 'capitalize', // ensures only first letter is capital
            }}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
      <Dialog open={openConfirmDialog} onClose={cancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this user? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            No
          </Button>
          <Button onClick={confirmDelete} color="error" autoFocus>
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
